import Founder from './Founders';

export default Founder;
